import * as Yup from 'yup'

export const CampaignSectionSchema = Yup.object().shape({
  name: Yup.string().trim().required('This field is required.').max(255, 'Name is too long.')
});
